import { type PropsWithChildren } from 'react';

type Props = {
  className?: string;
  center?: boolean;
};

const ScrollableText: React.FC<PropsWithChildren<Props>> = ({
  className,
  children,
  center = false
}) => {
  return (
    <div
      onMouseLeave={(e) => (e.currentTarget.scrollLeft = 0)}
      className={`${className} scrollable-text hide-scrollbar ${center ? 'flex items-center justify-center text-center' : ''}`}
    >
      <span className="w-full text-center">{children}</span>
    </div>
  );
};

export default ScrollableText;
